import {useEffect} from 'react';
import {create} from 'zustand';

export const initialState = {
  user: null,
  authToken: {},
  pageInfo: null,
  activeModule: null,
};

export const useAppStore = create((set) => ({
  ...initialState,
  setUser: (user) => set(() => ({user})),
  setAuthToken: (authToken) => set(() => ({authToken})),
  setPageInfo: (pageInfo) => set(() => ({pageInfo})),
  setActiveModule: (activeModule) => set(() => ({activeModule})),
}));

export const usePageInfo = () => {
  const {pageInfo, setPageInfo} = useAppStore();

  useEffect(() => {
    return () => {
      setPageInfo(null);
    };
  }, [setPageInfo]);

  return {pageInfo, setPageInfo};
};
